import { useMemo } from 'react'

import { FieldGroupFragment } from 'types/graphql'

import { FieldDisplay } from 'src/components/Field/FieldDisplay'
import FieldsDisplayTable from 'src/components/Field/FieldsDisplayTable'
import { useFieldGroupByIdQuery } from 'src/fetch/fieldGroups'
import { getFieldDisplayInputFromFieldFragment } from 'src/utils/field'

type Props = {
  childFieldGroupTemplateId: number | undefined | null
  childFieldGroups: FieldGroupFragment[] | undefined | null
}

const FieldGroupFieldDisplay = ({ childFieldGroupTemplateId, childFieldGroups }: Props) => {
  const { fieldGroupById, isLoading } = useFieldGroupByIdQuery(childFieldGroupTemplateId ?? 0)

  const rows = useMemo(
    () =>
      childFieldGroups?.map((fg) => ({
        id: `${fg.id}`,
        values:
          fg?.fields?.map((f) => (
            <FieldDisplay key={f.id} input={getFieldDisplayInputFromFieldFragment(f)} />
          )) ?? [],
      })) ?? [],
    [childFieldGroups]
  )

  return (
    <FieldsDisplayTable fieldTemplates={fieldGroupById.fields} rows={rows} isLoading={isLoading} />
  )
}

export default React.memo(FieldGroupFieldDisplay)
